import { toast } from "../toast/toast";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingOverlay from "../components/Loading";
import { useUser } from "../contexts/UserContext";
import { login } from "../fetch/UserRequest";
import { errorMessage } from "../function/errorMessage";
// import "../styles/Base.css";
// import "../styles/LoginPage.css";
import { getAlertsCount } from "../fetch/AlertRequest";
import styles from "../styles/modules/LoginPage.module.css";
import "../styles/sanitize.css";

function LoginPage() {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const { user, setUser, setMemberships, setLabs, setUserLabs, setAlertCount } =
    useUser();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/labs";

  useEffect(() => {
    if (user) {
      setTimeout(() => {
        navigate(from, { replace: true });
      }, 0);
    }
  }, [user]);

  //ボタンを押した場合の通常ログイン処理
  async function LoginRequest(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const form = e.target as HTMLFormElement;
    const student_no = (
      form.elements.namedItem("student_no") as HTMLInputElement
    ).value;
    const password = (form.elements.namedItem("password") as HTMLInputElement)
      .value;

    if (student_no === "" || password === "") {
      toast.error("学籍番号かパスワードが未入力です。");
      return;
    }

    setIsLoading(true);

    try {
      const result = await login({
        student_no: student_no,
        password: password,
      });

      if (result != null) {
        localStorage.setItem("sessionId", result.sessionId);
        setUser(result.user);
        setMemberships(result.memberships);
        setLabs(result.labs);

        const lab_idList = result.memberships
          .map((m) => m.lab_id)
          .filter((id): id is number => id !== null);

        const userLabList = result.labs.filter((lab) =>
          lab_idList.includes(lab.id),
        );

        const sortedLabList = Array.from(userLabList.values()).sort((a, b) =>
          a.name.localeCompare(b.name, "ja"),
        );

        setUserLabs(sortedLabList);

        const lab_ids = sortedLabList.map((lab) => lab.id);

        const alertCount = await getAlertsCount({
          tenant_id: result.user.tenant_id,
          lab_ids,
        });

        setAlertCount(alertCount);

        setTimeout(() => {
          navigate(from);
        }, 0);
      }
    } catch (error) {
      errorMessage("ログイン処理でエラーが発生しました", error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className={styles["parents-box"]}>
        <h2 id="login-text">試薬管理システム</h2>
        <form className={styles["login-form"]} onSubmit={LoginRequest}>
          <div>
            <label htmlFor="student_no">学籍番号</label>
            <input
              type="text"
              pattern="^.{6,}$"
              title="学籍番号は6文字以上で入力してください"
              id="student_no"
              name="student_no"
            />
          </div>
          <div>
            <label htmlFor="password">パスワード</label>
            <input type="password" id="password" name="password" />
          </div>
          <button type="submit" id="login-button">
            ログイン
          </button>
        </form>
      </div>

      {isLoading && <LoadingOverlay />}
    </>
  );
}

export default LoginPage;
